export default "__VITE_ASSET__Bstti3Jb__"